export enum PoHContract {
  PROOF_OF_HUMANITY = "PROOF_OF_HUMANITY",
  CROSS_CHAIN_POH = "CROSS_CHAIN_POH",
  ARBITRATOR = "ARBITRATOR",
}
